export default {
    data: () => ({
        translations: {
            title: {
                el: "Αλλαγή Κωδικού",
                en: "Change Password",
                it: "Cambiare la password"
            },
            password: {
                el: "Κωδικός",
                en: "Password",
                it: "Codice"
            },
            newPassword: {
                el: "Νέος Κωδικός",
                en: "New Password",
                it: "Nuovo codice"
            },
            confirmPassword: {
                el: "Επιβεβαίωση Κωδικού",
                en: "Confirm Password",
                it: "Conferma del codice"
            }
        }
    })
};
